/** @format */

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { DateRange } from "react-date-range";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import React, { useEffect, useState } from "react";

export default function DateRangeSelectDialog(props) {
  const { open, onClose, startDate, endDate, setStartDate, setEndDate } = props;
  const [dateRangeDate, setDateRangeDate] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const handleClose = (newData) => {
    if (newData) {
      setStartDate(dateRangeDate.startDate);
      setEndDate(dateRangeDate.endDate);
    }
    onClose();
  };

  useEffect(() => {
    setDateRangeDate({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog maxWidth={"sm"} open={open} onClose={() => handleClose(false)}>
      <DialogTitle>Change Date Range</DialogTitle>
      <DialogContent>
        <DateRange
          maxDate={new Date()}
          ranges={[dateRangeDate]}
          onChange={(value1) => {
            // console.log(value1);
            setDateRangeDate(value1.selection);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleClose();
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={async () => {
            handleClose(true);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
